import { render, staticRenderFns } from "./DocumentPOSCRUD.vue?vue&type=template&id=b7bfadb0"
import script from "./DocumentPOSCRUD.vue?vue&type=script&lang=js"
export * from "./DocumentPOSCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports